import { render, staticRenderFns } from "./Plunge.vue?vue&type=template&id=6ff3eee9&scoped=true&"
import script from "./Plunge.vue?vue&type=script&lang=js&"
export * from "./Plunge.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff3eee9",
  null
  
)

export default component.exports